module.exports = __webpack_public_path__ + "img/22080801.76b36620.jpg";